import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { message, Row, Col } from "antd";

import { CardElement } from "../../../../components/Common/UIElements";
import PropertyDetailsForm from "../../../../components/Onboarding/PropertyDetailsForm/PropertyDetailsForm";
import { Button, ButtonPrimary } from "../../../../components/Common/Button";
import { onboardingPropertyEditSchema } from "../../../../schema/onboarding-properties.schema";
import useQuery from "../../../../hooks/url.hooks";
import {
  useGetPropertyById,
  useApproveProperty,
} from "../../../../hooks/Onboarding/onboarding-properties.hooks";

const PropContactPropertyApprover = ({ propertyId, refetchProperty }) => {
  const { data: apiPropertyData } = useGetPropertyById(propertyId, {
    enabled: !!propertyId,
    select: (data) => {
      return {
        ...data,
        property_contact: {
          _id: data?.property_contact_id?._id,
          first_name: data?.property_contact_id?.first_name,
          last_name: data?.property_contact_id?.last_name,
          email: data?.property_contact_id?.email,
          customer_id: data?.property_contact_id?.customer_id,
        },
      };
    },
  });

  const { handleSubmit, control, formState, reset } = useForm({
    mode: "onChange",
    resolver: yupResolver(onboardingPropertyEditSchema),
  });

  useEffect(() => {
    if (apiPropertyData) {
      reset({ ...apiPropertyData });
    }
  }, [apiPropertyData]);

  const { mutate: approveProperty, isLoading: approvePropertyLoading } =
    useApproveProperty({
      onSuccess: () => {
        message.success("Property approval success");
        refetchProperty();
      },
      onError: (error) => {
        message.error(error.response?.data?.message ?? "Server Error");
      },
    });

  const approvePropertyDetails = (formData) => {
    if (formData?.customer_id) {
      approveProperty({
        propertyList: [formData],
        customerId: formData.customer_id,
      });
    }
  };

  const clickCancel = () => {
    // history.push("/onboarding/dashboard");
  };

  return (
    <>
      <CardElement title="System Discovery">
        <Row>
          <Col span={24}>
            <div className="card-header">Let's set up Your Property</div>
            <div className="card-sub-header">
              Your data has already been entered and approved by a corporate
              contact
            </div>
          </Col>
        </Row>
        <Row>
          <PropertyDetailsForm
            control={control}
            errors={formState.errors}
            disableStatus={apiPropertyData?.status === "Approved"}
          />
        </Row>
        <Row>
          <Col span={24} style={{ textAlign: "center" }}>
            <Button
              style={{ width: "150px" }}
              htmlType="button"
              onClick={clickCancel}
              disabled
            >
              Go to Dashboard
            </Button>
            <ButtonPrimary
              style={{ width: "150px" }}
              onClick={handleSubmit(approvePropertyDetails)}
              loading={approvePropertyLoading}
            >
              Approve
            </ButtonPrimary>
          </Col>
        </Row>
      </CardElement>
    </>
  );
};

export default PropContactPropertyApprover;
